<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :data="issuesList"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
      :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
      @edit-closed="editClosed"
      :edit-rules="rules"
    >
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:reworkBy="{ row }">
        <el-select
          v-model="row.reworkBy"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
          size="mini"
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in userData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:result="{ row }">
        <el-select
          v-model="row.status"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
          size="mini"
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in statusData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { request } from '@/api/service'
export default {
  mixins: [],
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    issuesList: { type: Array, default: () => [] },
    status: { type: String, default: '' },
  },
  computed: {
    tableColumns() {
      return [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 60,
          slots: {
            default: 'opt',
          },
          visible: !this.disabled,
        },
        {
          title: this.$l('table_label_reworkByName') || '返修人',
          field: 'reworkByName',
          minWidth: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          visible: ['C', 'R', 'Y'].includes(this.status),
          editRender: { enable: true },
          slots: { edit: 'reworkBy' },
        },
        {
          title: this.$l('table_label_result') || '复检结果',
          field: 'statusText',
          minWidth: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: { edit: 'result' },
          visible: ['Y', 'C'].includes(this.status),
          editRender: { enable: true },
        },
        {
          title: this.$l('table_label_notPassQty') || '不良品数量',
          field: 'notPassQty',
          minWidth: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_qualityIssuesTitle') || '不良原因',
          field: 'qualityIssuesTitle',
          minWidth: 400,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
        },
      ]
    },
    rules() {
      return {
        reworkByName: [
          {
            required: ['C', 'Y'].includes(this.status),
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        statusText: [
          {
            required: ['Y'].includes(this.status),
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      }
    },
  },
  async mounted() {
    await this.getOptionData()
    await this.getUserOptionData()
  },
  data() {
    return {
      tableHeight: 250,
      statusData: [],
      allStatusData: [],
      userData: [],
      userDialogVisible: false,
    }
  },
  methods: {
    async getOptionData() {
      request({
        url: '/master/common/dict/biz',
        method: 'POST',
        data: { dictType: 'mrpPendingGoodsQualityIssuesStatus' },
      }).then((res) => {
        this.allStatusData = res.body.data || []
        this.statusData = this.allStatusData.filter((i) => i.value !== 'N')
      })
    },
    async getUserOptionData() {
      request({
        url: '/sys/user/workshop/selectList',
        method: 'POST',
        data: {},
      }).then((res) => {
        this.userData = res.body.data || []
      })
    },
    openChooseGoods() {
      this.userDialogVisible = true
    },
    //单行删除
    del(row) {
      let index = this.$refs.vxeGrid.getRowIndex(row)
      this.$emit('del', index)
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    editClosed({ row }) {
      const findData =
        this.allStatusData.find((item) => item.value == row.status) || {}
      const findUserData =
        this.userData.find((item) => item.value == row.reworkBy) || {}
      let index = this.$refs.vxeGrid.getRowIndex(row)
      this.$emit('update', {
        index,
        statusText: findData.label || null,
        status: findData.value || null,
        reworkByName: findUserData.label,
        reworkBy: findUserData.value,
        userNo: findUserData.userNo,
      })
    },
    async validate() {
      return !(await this.$refs.vxeGrid.validate(true))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .vxe-toolbar.size--mini {
  font-size: 12px;
  height: 25px;
}
</style>
